import Vue from 'vue'

import { Services } from '@sigma-frontend-libs/commons'

import { components } from '@/utils'

import buttonUpDown from '@/components/button/upDown'
import selectorSendingType from '@/components/selector/sendingType'
import TariffsRules from '@/components/services/tariffs/rules'
import TariffsDefaultRule from '@/components/services/tariffs/rules/rule/default'

function renderTypeField(h) {
  return h(
    selectorSendingType,
    {
      props: {
        value: this.proxy.source,
        label: this.getTranslate(`${Services.tariffs}.labels.source`),
        items: this.sourceItems,
        required: true
      },
      on: {
        input: event => {
          this.proxy.source = event
        }
      }
    }
  )
}

function renderTariffRules(h) {
  let rulesSource
  if (this.proxy.source) {
    rulesSource = this.proxy.source.split('.')[1]
  }

  return h(
    TariffsRules,
    {
      props: {
        value: this.proxy.data.rules,
        source: rulesSource,
        isNew: this.isNew,
        hasDefault: !!this.proxy._defaultRule
      },
      on: {
        input: event => {
          this.proxy.data.rules = event
        }
      }
    }
  )
}

function renderDefaultRule(h) {
  if (this.proxy._defaultRule) {
    let defaultRuleSource
    if (this.proxy.source) {
      defaultRuleSource = this.proxy.source.split('.')[1]
    }

    return h(
      TariffsDefaultRule,
      {
        props: {
          value: this.proxy._defaultRule,
          isMultiple: !!(this.proxy.data.rules.length > 0),
          source: defaultRuleSource
        },
        on: {
          input: event => {
            this.proxy._defaultRule = event
          },
          remove: () => {
            Vue.delete(this.proxy, '_defaultRule')
          }
        }
      }
    )
  }
}
function renderPriceRangesCustomKey(h) {
  if (this.sourceIsLegacySendingType) {
    return h(
      components['text-field'],
      {
        props: {
          value: this.proxy.data.options.priceRangesCustomKey,
          label: this.getTranslate(`${Services.tariffs}.labels.priceRangesCustomKey`),
          hint: this.getTranslate(`${Services.tariffs}.hints.priceRangesCustomKey`),
          maxlength: 150,
          dense: true,
          details: true,
          clearable: true
        },
        on: {
          input: event => {
            this.proxy.data.options.priceRangesCustomKey = event
          }
        }
      }
    )
  }
}
function renderRefund(h) {
  if (this.sourceIsLegacySendingType) {
    return h(
      components.switch,
      {
        props: {
          value: this.proxy.data.options.refundOnFailed,
          label: this.getTranslate(`${Services.tariffs}.labels.refundOnFailed`)
        },
        on: {
          input: event => {
            this.proxy.data.options.refundOnFailed = event
          }
        }
      }
    )
  }
}
function renderNoPayments(h) {
  if (this.sourceIsLegacySendingType) {
    return h(
      components.switch,
      {
        props: {
          value: this.proxy.data.options.noPayments,
          label: this.getTranslate(`${Services.tariffs}.labels.noPayments`)
        },
        on: {
          input: event => {
            this.proxy.data.options.noPayments = event
          }
        }
      }
    )
  }
}
function renderPriceRangesUseSendernameInKey(h) {
  if (this.sourceIsLegacySendingType) {
    return h(
      components.switch,
      {
        props: {
          value: this.proxy.data.options.priceRangesUseSendernameInKey,
          label: this.getTranslate(`${Services.tariffs}.labels.priceRangesUseSendernameInKey`)
        },
        on: {
          input: event => {
            this.proxy.data.options.priceRangesUseSendernameInKey = event
          }
        }
      }
    )
  }
}
function renderSwitches(h) {
  if (this.sourceIsLegacySendingType) {
    return h(
      components.card,
      {
        class: `${Services.tariffs}-form-switches`,
        props: {
          outline: true,
          rounded: true
        }
      },
      [
        renderRefund.call(this, h),
        renderNoPayments.call(this, h),
        renderPriceRangesUseSendernameInKey.call(this, h)
      ]
    )
  }
}
function renderCommentField(h) {
  return h(
    components.textarea,
    {
      props: {
        value: this.proxy.data.hidden.comment,
        label: this.getTranslate(`${Services.tariffs}.labels.comment`),
        grow: true,
        details: false
      },
      on: {
        input: event => {
          this.proxy.data.hidden.comment = event
        }
      }
    }
  )
}
function renderOptionalFields(h) {
  return h(
    'div',
    {
      class: {
        [`${Services.tariffs}-form-optional`]: true,
        [`${Services.tariffs}-form-optional--legacy`]: this.sourceIsLegacySendingType
      }
    },
    [
      renderPriceRangesCustomKey.call(this, h),
      renderSwitches.call(this, h),
      renderCommentField.call(this, h)
    ]
  )
}

export default function(h) {
  return h(
    components.form,
    {
      class: {
        [`${Services.tariffs}-form`]: true,
        [`${Services.tariffs}-form--new`]: this.isNew
      }
    },
    [
      renderTypeField.call(this, h),
      renderTariffRules.call(this, h),
      renderDefaultRule.call(this, h),
      renderOptionalFields.call(this, h),

      h(buttonUpDown)
    ]
  )
}
